<template>
    <div class="columns is-centered">
        <div class="column is-6">
            <form @submit.prevent="submit">
                <h4 class="title is-4">
                    Reset your password
                </h4>

                <p class="subtitle">
                    Enter your email address to receive an email with password reset instructions.
                </p>

                <FormNotification />

                <SavingNotification>Sending...</SavingNotification>

                <b-field label="Email">
                    <b-input
                        v-model="Email"
                        v-validate="{ required: true, email: true }"
                        type="email"
                        name="Email"
                    />
                </b-field>

                <b-button
                    type="is-info"
                    tag="button"
                    :disabled="isButtonDisabled"
                    native-type="submit"
                >
                    Submit
                </b-button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Form from '../../mixins/form.js';

export default {
    mixins: [
        Form,
    ],

    computed: {
        ...mapFields('user', [
            'user.Email',
        ]),
        isButtonDisabled() {
            return this.isSending || this.isSuccess || ! this.Email || this.errors.first('Email');
        },
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
                .then((result) => {
                    if (! result) {
                        return;
                    }

                    this.$store.dispatch('user/recover')
                    .then((response) => {
                        this.statusMessage = response.data.message;
                        this.statusType = 'success';
                        this.isSuccess = true;
                    })
                    .catch((error) => {
                        this.parseServerErrors(error);
                        this.isSuccess = false;
                    })
                    .then(() => {
                        this.isSending = false;
                    });
                });
        },
    },
};
</script>
